import { UseFormReturn } from "react-hook-form";
import { clientOnboardingType } from "../../validator";
import useCurrentUserStore from "@/store";
import WhiteLogo from "@/components/icons/WhiteLogo";
import GenBlogInitComponent from "./GenBlogInitComponent";
import BlogContentPreviewComponent from "./BlogContentPreviewComponent";

type PropTypes = {
  form: UseFormReturn<clientOnboardingType>;
};

const Step5ContentPreview: React.FC<PropTypes> = () => {
  const { generatedBlog, blogImage, isBlogGenerating } = useCurrentUserStore();

  return (
    <div className="bg-primary lg:rounded-[20px] shadow-md p-6 lg:p-10 text-white flex flex-col justify-center lg:items-center lg:h-[calc(100%-0.5rem)] lg:relative lg:object-cover lg:mt-1">
      <WhiteLogo />

      {isBlogGenerating ? (
        <BlogContentPreviewComponent content={""} loading={true} />
      ) : generatedBlog && blogImage ? (
        <BlogContentPreviewComponent
          // title={JSON.parse(generatedBlog)?.title}
          content={JSON.parse(generatedBlog)?.blog_content}
          loading={false}
        />
      ) : (
        <GenBlogInitComponent />
      )}
    </div>
  );
};

export default Step5ContentPreview;
